import { render, staticRenderFns } from "./ResultModal.vue?vue&type=template&id=14753186&scoped=true&"
import script from "./ResultModal.vue?vue&type=script&lang=js&"
export * from "./ResultModal.vue?vue&type=script&lang=js&"
import style0 from "./ResultModal.vue?vue&type=style&index=0&id=14753186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14753186",
  null
  
)

export default component.exports